<mat-icon class="search-icon" [svgIcon]="IconNames.ice_search" />

<input
  #searchInput
  class="search-input"
  data-testid="search-input"
  type="search"
  [placeholder]="placeholder"
  [(ngModel)]="value"
  (keydown.enter)="onEnter()"
  (ngModelChange)="valueSubject.next($event)"
/>

@if (!!value) {
  <app-ice-icon-button testId="clear-search-input-button" [iconName]="IconNames.ice_close" (clicked)="clearSearch()" />
}
